import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import( '../views/LoginView.vue')
  },
  {
    path: '/layout',
    redirect: '/home',
    component: () => import('../views/Layout/LayoutView.vue'),
    children: [
      {
        path: '/home',
        component: () => import('../views/Home/HomeView.vue')
      },
      {
        path: '/order',
        component: () => import('@/views/Record/OnlineOrder.vue')
      },
      {
        path: '/parkManagementReport',
        component: () => import('@/views/Record/ParkManageReport.vue')
      },
      {
        path: '/issuance-recharge-order',
        component: () => import('@/views/Record/IssuanceRecharge.vue')
      },
      {
        path: '/carAccessRecordReport',
        component: () => import('@/views/Record/CarReportOrder.vue')
      },
      {
        path: '/newFeeReport',
        component: () => import('@/views/Record/NewFeeReport.vue')
      },
      {
        path: '/carInsideReport',
        component: () => import('@/views/Record/InsideCarReport.vue')
      },
      {
        path: '/carInOutReport',
        component: () => import('@/views/Record/CarInOutReport.vue')
      },
      {
        path: '/couponConfig',
        component: () => import('@/views/Coupon/CouponConfig/CouponConfig.vue')
      },
      {
        path: '/sellerCoupon',
        component: () => import('@/views/Coupon/SellerCoupon/SellerCoupon.vue')
      },
      {
        path: '/couponDispatchItem',
        component: () => import('@/views/Coupon/CouponDispatchItem/CouponDispatchItem.vue')
      },
      {
        path: '/couponDispatch',
        component: () => import('@/views/Coupon/CouponDispatch/CouponDispatch.vue')
      },
      {
        path: '/sellerCouponPrint',
        component: () => import('@/views/Coupon/SellerCouponPrint/SellerCouponPrint.vue')
      }
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
